import React from "react";
import { useTranslation } from "react-i18next";
import HardwareFeatures from "../HardwareFeatures";
import { RinghardwareFeatures, colorTheme } from "./Ringdata";

const RingHardwareFeatures: React.FC = () => {
    const { t } = useTranslation("hardwareFeatures");

    return (
        <HardwareFeatures
            features={RinghardwareFeatures}
            colorTheme={colorTheme}
            regularText={t("ring.regularText")}
            highlightedText={t("ring.highlightedText")}
            descriptionText={t("ring.descriptionText")}
        />
    );
};
export default RingHardwareFeatures;
